import { StateCreator } from 'zustand';
import {
  Alert,
  Allergy,
  AnthemCareTeam,
  AnthemCareTeamDetails,
  Assessment,
  Authorization,
  CareGap,
  ConditionHistoryRecords,
  ContactEmailRecord,
  ContactRecord,
  Directive,
  Documents,
  DrugInteractions,
  GNACases,
  GoodtToKnow,
  HealthHistoryTrends,
  IdCards,
  ImmunizationsList,
  MailFaxRecords,
  MedicationsList,
  Member,
  MemberConditions,
  MemberDoc,
  MemberStore,
  OpportunitiesAndCelebrations,
  OverutilizationDetails,
  PcpDetails,
  ProgramsAndWaivers,
  SmsChatRecords,
  SocialInfo,
  ValueAdd
} from '@interfaces/member-store';

const initialState = {
  memberDetails: {
    member: {} as Member,
    alerts: [] as Alert[],
    anthemCareTeam: [] as AnthemCareTeam[],
    programsAndWaivers: {} as ProgramsAndWaivers,
    valueAdd: {} as ValueAdd,
    socialInfo: [] as SocialInfo[],
    opportunitiesAndCelebrations: {} as OpportunitiesAndCelebrations,
    pcpDetails: {} as PcpDetails,
    careGaps: [] as CareGap[],
    authorizations: [] as Authorization[],
    goodtToKnow: [] as GoodtToKnow[],
    assessments: [] as Assessment[],
    assessmentDocs: [] as MemberDoc[],
    contactRecords: [] as ContactRecord[],
    contactEmailRecords: [] as ContactEmailRecord[],
    drugInteractions: [] as DrugInteractions[],
    medicationsList: [] as MedicationsList[],
    mailFaxRecords: [] as MailFaxRecords[],
    smsChatRecords: [] as SmsChatRecords[],
    overutilizationList: {} as OverutilizationDetails,
    idCardsList: [] as IdCards[],
    immunizationsList: [] as ImmunizationsList[],
    healthHistoryTrends: {} as HealthHistoryTrends,
    allergy: [] as Allergy[],
    directive: [] as Directive[],
    GNACasesList: [] as GNACases[],
    documents: [] as Documents[],
    conditionHistoryRecords: [] as ConditionHistoryRecords[],
    memberConditions: [] as MemberConditions[],
    anthemCareTeamDetails: [] as AnthemCareTeamDetails[],
    ltssProgramDetails: {} as any
  }
};

export const MemberSlice: StateCreator<MemberStore> = (set) => ({
  ...initialState,
  updateMember: (member: Member) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, member } })),
  updateAlerts: (alerts: Alert[]) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, alerts } })),
  updateAnthemCareTeam: (anthemCareTeam: AnthemCareTeam[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, anthemCareTeam }
    })),
    updateAnthemCareTeamDetails: (anthemCareTeamDetails: AnthemCareTeamDetails[]) =>
      set((state) => ({
        memberDetails: { ...state.memberDetails, anthemCareTeamDetails }
      })),
  updateProgramsAndWaivers: (programsAndWaivers: ProgramsAndWaivers) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, programsAndWaivers }
    })),
  updateValueAdd: (valueAdd: ValueAdd) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, valueAdd } })),
  updateSocialInfo: (socialInfo: SocialInfo[]) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, socialInfo } })),
  updateOpportunitiesAndCelebrations: (
    opportunitiesAndCelebrations: OpportunitiesAndCelebrations
  ) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, opportunitiesAndCelebrations }
    })),
  updatePcpDetails: (pcpDetails: PcpDetails) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, pcpDetails } })),
  updateCareGaps: (careGaps: CareGap[]) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, careGaps } })),
  updateAuthorizations: (authorizations: Authorization[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, authorizations }
    })),
  updateGoodtToKnow: (goodtToKnow: GoodtToKnow[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, goodtToKnow }
    })),
  updateAssessments: (assessments: Assessment[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, assessments }
    })),
  updateAssessmentDocs: (assessmentDocs: MemberDoc[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, assessmentDocs }
    })),
  updateContactRecords: (contactRecords: ContactRecord[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, contactRecords }
    })),
  updateContactEmailRecords: (contactEmailRecords: ContactEmailRecord[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, contactEmailRecords }
    })),
  updateDrugInteractions: (drugInteractions: DrugInteractions[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, drugInteractions }
    })),
  updateMedicationList: (medicationsList: MedicationsList[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, medicationsList }
    })),
  updateMailFaxRecords: (mailFaxRecords: MailFaxRecords[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, mailFaxRecords }
    })),
  updateSmsChatRecords: (smsChatRecords: SmsChatRecords[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, smsChatRecords }
    })),
  updateOverutilizationDetails: (overutilizationList: OverutilizationDetails) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, overutilizationList }
    })),
  updateIdCards: (idCardsList: IdCards[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, idCardsList }
    })),
  updateImmunizations: (immunizationsList: ImmunizationsList[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, immunizationsList }
    })),
  upateHealthHistoryTrends: (healthHistoryTrends: HealthHistoryTrends) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, healthHistoryTrends }
    })),
  updateAllergy: (allergy: Allergy[]) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, allergy } })),
  updateAdvanceDirective: (directive: Directive[]) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, directive } })),
  updateGNACases: (GNACasesList: GNACases[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, GNACasesList }
    })),
  updateDocuments: (documents: Documents[]) =>
    set((state) => ({ memberDetails: { ...state.memberDetails, documents } })),
  updateLtssProgramDetails: (ltssProgramDetails: any) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, ltssProgramDetails }
    })),
  updateConditionHistoryRecords: (
    conditionHistoryRecords: ConditionHistoryRecords[]
  ) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, conditionHistoryRecords }
    })),
  updateMemberConditions: (memberConditions: MemberConditions[]) =>
    set((state) => ({
      memberDetails: { ...state.memberDetails, memberConditions }
    })),
  resetMemberStore: () => set(initialState)
});
